import React from 'react'

const IptvFavorite = ({ color = '#fff', style = {}, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="XMLID_298_"
      fill={color}
      style={style}
      version="1.1"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        id="favorite"
        d="m12 23.2-.6-.5C8.7 20.7 0 13.5 0 7.3 0 3.8 2.9 1 6.5 1c2.2 0 4.3 1.1 5.5 2.9C13.2 2.1 15.3 1 17.5 1 21.1 1 24 3.8 24 7.3c0 6.3-8.7 13.4-11.4 15.5zM6.5 2.9C4 2.9 2 4.8 2 7.2c0 4.1 5.1 9.5 10 13.4 4.9-3.9 10-9.3 10-13.4 0-2.4-2-4.3-4.5-4.3-1.6 0-3 .8-3.8 2L12 7.6 10.3 5c-.8-1.3-2.2-2.1-3.8-2.1"
      ></path>
    </svg>
  )
}

export default IptvFavorite
